import { Component } from "@angular/core";

@Component({
  selector: "spx-logo-svg",
  templateUrl: "./spx-logo.component.svg",
  styleUrls: ["./spx-logo.component.scss"],
})
export class SpxLogoSvgComponent { }
